import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "toolbar";
var attributes = {
    INVERTED: 'inverted'
};
var classes = {
    INVERTED: 'tyl-toolbar--inverted',
    TOOLBAR: 'tyl-toolbar',
    SECTION: 'tyl-toolbar__section',
    ALIGN_START: 'tyl-toolbar__section--align-start',
    ALIGN_CENTER: 'tyl-toolbar__section--align-center',
    ALIGN_END: 'tyl-toolbar__section--align-end'
};
var selectors = {
    TOOLBAR: "." + classes.TOOLBAR,
    START_SLOT: "." + classes.SECTION + "." + classes.ALIGN_START + " > slot[name=start]",
    CENTER_SLOT: "." + classes.SECTION + "." + classes.ALIGN_CENTER + " > slot[name=center]",
    END_SLOT: "." + classes.SECTION + "." + classes.ALIGN_END + " > slot[name=end]",
};
export var TOOLBAR_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    selectors: selectors
};
